import styled, { css, keyframes } from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";
import { Link, NavLink } from "react-router-dom";

export const NavigationWrapper = styled.nav`
  height: 60px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.5rem 0rem;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  color: ${DIGIPOSTHEME.colors.headerRed};

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 75px;
  }
`;

export const MenuTitle = styled.a`
  text-decoration: none;
  color: ${DIGIPOSTHEME.colors.headerRed};
  font-size: 1.3rem;
  margin-left: 1rem;
  cursor: pointer;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  padding: 10px;

  &:hover {
    background-color: ${DIGIPOSTHEME.colors.footerGrey};
    color: ${DIGIPOSTHEME.colors.headerRed};
    border-radius: 5px;
  }
`;

export const moveLeftToRight = keyframes`
0% {
   opacity: 0;   
   transform: translateX(-100%);
  }

  50% {
    opacity: 0.5;
  }
  
  100% {
    opacity: 1;    
    transform: translate(0);
  }
`;

export const NavigationMenu = styled.div`
  margin-left: auto;
`;
export const List = styled.ul`
  display: flex;
  padding: 0;
  background-color: ${DIGIPOSTHEME.colors.transparent};

  @media ${MEDIA_QUERIES.MOBILE} {
    animation: ${moveLeftToRight} 0.7s ease-in-out;
    position: absolute;
    top: 60px;
    left: 0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    width: calc(100vw - 1%);
    height: calc(100vh - 100%);
    background-color: white;
    border-radius: 5px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
      rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    display: none;
  }
`;
export const ListItem = styled.li`
  list-style-type: none;
  margin: 0 1rem;
  color: ${DIGIPOSTHEME.colors.secondaryAkbankWhite};
  padding: 5px;
  font-size: 14px;
  font-family: Campton;

  height: 62px;
  display: flex;
  align-items: center;

  @media ${MEDIA_QUERIES.MOBILE} {
    text-align: center;
    margin: 1px;
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;

    &:hover {
      border-bottom: 4px solid #e0e0e0;
    }

    &:active {
      border-bottom: 4px solid #e0e0e0;
    }
  }

  &:hover {
    border-bottom: 4px solid #e0e0e0;
  }

  &:active {
    border-bottom: 4px solid #e0e0e0;
  }
  &:visited {
    border-bottom: 4px solid #e0e0e0;
  }
`;
export const ListItemMenu = styled.a`
  text-decoration: none;
  display: block;
  width: 100%;
  cursor: pointer;
  background-color: ${DIGIPOSTHEME.colors.transparent};

  @media ${MEDIA_QUERIES.MOBILE} {
    color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
    width: 100%;
    padding: 5px;

    &:hover {
      color: ${DIGIPOSTHEME.colors.headerRed};
    }
  }
`;

export const StyledActiveLink = css`
  border-bottom: 4px solid #e0e0e0;
`;

export const Hambuger = styled.button`
  border: 0;
  height: 40px;
  width: 40px;
  padding: 0.5rem;
  border-radius: 50%;
  color: ${DIGIPOSTHEME.colors.headerRed};
  background-color: ${DIGIPOSTHEME.colors.secondaryAkbankWhite};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  display: none;

  &:hover {
    background-color: #ebebec;
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    display: block;
  }

  svg {
    background-color: ${DIGIPOSTHEME.colors.transparent};
  }
`;

export const NavigationMenuExpand = styled(NavigationMenu)`
  @media ${MEDIA_QUERIES.MOBILE} {
    ul {
      display: block;
    }
  }
`;
